import { createClient } from "@supabase/supabase-js";

// Clave ANON (pública por diseño, restringida por RLS). NUNCA poner acá la
// service-role key: este archivo se embebe en el bundle del navegador.
const supabaseUrl = "https://peuhseswtlexeijsmmvu.supabase.co";
const supabaseKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InBldWhzZXN3dGxleGVpanNtbXZ1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDM4NTYwMDIsImV4cCI6MjA1OTQzMjAwMn0._5recilenozkARlN0m_QGDnhXoOlJOCEmTFhTWhcrQ8";

// Configuración simple y funcional
export const supabase = createClient(supabaseUrl, supabaseKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});

// console.log("🔧 Supabase configurado correctamente");
